<template>
    <div style="height:100%;" v-loading="iframeLoading">
        <iframe class="lnk-frame"
                id="lnk-iframe"
                scrolling="auto"
                frameborder="0"
                style=""
                :src="src" ></iframe>
        <!--<div id="iframe-mask" style="width: 100%;background: white;position: absolute;top:0;display: none;"></div>-->
    </div>
</template>

<script>
var iframeLoadingIndex = -1;
export default {
    name: 'lnk-crm-iframe',
    data(){
        return {
            // loadingIndex: -1, // 加载动画编号
            iframeLoading: false // 遮罩
        };
    },
    computed: {
        src(){
            // this.iframeLoading = true;
            if(this.$route.params.src){
                const urlRegExp = /http(s)?:\/\/+(\/[.\/?%&=]*)?/i; // 判断是否url正则表达式
                if(this.$route.params.src.startsWith(appCtx.cdnPath)){ // 由页面调用gotoContentPage后跳转的路径
                    return `${this.$route.params.src}`;
                }else if(urlRegExp.test(this.$route.params.src)){
                    return `${this.$route.params.src}`; // 完整url路径
                }else{
                    return `${appCtx.cdnPath}${this.$route.params.src}`; // 由菜单进入
                }
            }else{
                return '';
            }
        }
    },
    watch: {
        // 监听页面变化
        src(val){
            if(iframeLoadingIndex === -1 && val){
                iframeLoadingIndex = this.$lnkLoading.start('正在加载页面~');
                // console.log(iframeLoadingIndex);
            }
        }
    },
    mounted(){
        var iframe = document.getElementById('lnk-iframe');
        var that = this;
        iframe.onload = function() {
            // console.log(iframeLoadingIndex);
            that.$lnkLoading.finish(iframeLoadingIndex); // iframeLoading定义在全局，这样再次进来才可销毁，组件重复加载问题没好之前暂时先这么用着
            iframeLoadingIndex = -1;
            iframe.style.visibility = 'visible';
        };
    },
    /* created(){
        console.log('created');
    },
    activated(){
        console.log('activated');
    },

    beforeDestroy(){
        console.log('beforeDestroy');
    },*/
    deactivated(){
        // console.log('deactivated', iframeLoadingIndex);
        this.$lnkLoading.finish(iframeLoadingIndex);
    }
};
</script>

<style scoped>
    .lnk-frame{
        width: 100%;
        height: 100%;
        background-color: rgba(216,220,228,1);
        visibility: hidden;
    }
</style>
